import {Injectable} from '@angular/core';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {Platform} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class PicturesPermissionService {

    constructor(private androidPermissions: AndroidPermissions,
                private platform: Platform) {
    }

    async checkPermissions() {
        console.log('Requesting Permission');
        console.log(this.platform.is('android'));
        if ((this.platform.is('android') || this.platform.is('ios')) && !(this.platform.is('mobileweb'))) {
            console.log('Requesting Permission');
            const result = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA);
            if (!result.hasPermission) {
                await this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.CAMERA, this.androidPermissions.PERMISSION.GET_ACCOUNTS]);
            }
        }
    }
}
